import MarketingLayout from "@/components/MarketingLayout";
import SEOPageNew from "@/pages/newsite/SEOPageNew";

export default function GoogleAdsAnalysisPage() {
  return (
    <MarketingLayout>
      <SEOPageNew />
    </MarketingLayout>
  );
}
